/**
 * Cheap Flight Finder — fare-search helper
 *
 * A single web-accessible-resource group exposes content/interceptor.js, static/images/*
 * and favicon.ico to every origin, with no use_dynamic_url — so each sits at a fixed,
 * fetchable URL. The vendor-named toolbar PNGs load through an <img> with no CORS grant,
 * so they survive a strict page CSP.
 *
 * Manifest verified against version 1.7.16.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'papdhfmmdhepoeeimnkdhnadpmemeamk';

export const cheapFlightFinder: ExtensionDefinition = {
  id: ID,
  name: 'Cheap Flight Finder',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'interceptor.js plus static/images/* exposed to every origin with no dynamic URL. ' +
    'The icons load without a CORS grant; the interceptor fetch corroborates.',
  signals: [
    {
      id: 'war-icon-new',
      kind: 'web-accessible-resource',
      description:
        'Load static/images/icon_new.png via <img> — a toolbar icon exposed to every ' +
        'origin, reachable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'static/images/icon_new.png'),
    },
    {
      id: 'war-icon-new-active',
      kind: 'web-accessible-resource',
      description:
        'Load static/images/icon_new_active.png via <img> — the active-state icon, a ' +
        'second image path.',
      weight: 0.5,
      run: () => probeImage(ID, 'static/images/icon_new_active.png'),
    },
    {
      id: 'war-interceptor-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch content/interceptor.js — the injected fare interceptor, independent of ' +
        'the icon signals.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content/interceptor.js'),
    },
  ],
};
